"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LINKS_LIST = exports.LINK = void 0;
const LINKS_LIST = exports.LINKS_LIST = 'list';
const LINK = exports.LINK = 'link';